import { AppThemeService } from '@affine/core/modules/theme';
import { useService } from '@toeverything/infra';
import { ThemeProvider as NextThemeProvider } from 'next-themes';
import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

function ThemeObserver() {
  const service = useService(AppThemeService);

  useEffect(() => {
    service.appTheme.theme$.next('light');
  }, [service.appTheme.theme$]);

  return null;
}

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  return (
    <NextThemeProvider themes={['light']} enableSystem={false}>
      {children}
      <ThemeObserver />
    </NextThemeProvider>
  );
};
